const initialState = {
  paymentInfo: {
    busy: false,
    error: '',
    entity: {},
  },
}

export default (state = initialState, { type } = {}) => {
  switch (type) {
    default:
      return state
  }
}
